export default {
    namespaced: true,
    state: {
        //使用说明
        explain: "1.优惠卷有一定有效期，领取后请尽快使用。" +
            "2.该优惠卷不与其它优惠活动叠加。",
        // 有效期
        duration: "1",
        //起止时间
        //参与条件
        condition: ['1'],
        //所需金额
        money: "",
        //所需积分
        points: "",
        // 库存
        stock: "",
        // 每人可领
        limit: "",
        // 活动时间
        start_time: "",
        end_time: "",
        /* // 可直接领取
        pickup_directly: "",
        // 支付后赠送
        pay_give: "",
        // 购买商品赠送
        buy_give: "", */
        // 是否可转赠
        transfer: "1"
    },
    actions: {

    },
    mutations: {
        COMMONCHANGE(state, { e, name }) {
            // console.log(e, name)
            state[name] = e;
        }
    }
}